export type Retentions = Record<string, number>

export const retentions = {
  month: 3.59,
  quarter: 2.44,
  week: 5.48,
  year: 1.41,
} satisfies Retentions
